import * as React from 'react';

import { IPhone } from '../../../../api/offer';
import { formatPhone } from '../../../../utils/format_phone';
import ObjectPhoneShow from '../../../common/components/object_phone_show/object_phone_show';

import { ISerpObjectPhoneOpenEvent, ISerpObjectPhoneOpenProduct, trackingSerpObjectPhoneOpen } from '../../tracking';
interface IBSCSepPhoneShowProps {
  id: number;
  phones: IPhone[];
  trackingData: ISerpObjectPhoneOpenEvent;
  trackingProduct?: ISerpObjectPhoneOpenProduct;
  phoneStatisticToken: string;
}

const BSCSerpPhoneShow: React.StatelessComponent<IBSCSepPhoneShowProps> = (props) => {
  const {
    bsCenterId, bsCenterType, representativeType,
    fromDeveloper, geo, offrepExists
  } = props.trackingData;
  const { id, phones, phoneStatisticToken } = props;
  return (
    <ObjectPhoneShow
      buttonStyle="cf-bsc-li-contact-phones-button"
      phoneListStyle="cf-bsc-li-contact-phones-list"
      phones={phones.map(phone => {
        const { countryCode, code, number: phoneNumber } = phone;
        return formatPhone(`${countryCode || ''}${code || ''}${phoneNumber || ''}`);
      })}
      onPhoneShow={() => trackingSerpObjectPhoneOpen({
        id,
        bsCenterId,
        bsCenterType,
        geo,
        representativeType,
        fromDeveloper,
        offrepExists,
        phones,
        trackingProduct: props.trackingProduct,
      }, phoneStatisticToken)}
    />
  );
};

export default BSCSerpPhoneShow;



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_centers_serp/components/bsc_serp_phone_show/bsc_serp_phone_show.tsx